// data.js
const productp = [
    {
      id: 1,
      image: 'https://plus.unsplash.com/premium_photo-1687757692835-7d484898b2dc?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 1 Description',
    },
    {
      id: 2,
      image: 'https://plus.unsplash.com/premium_photo-1687757693334-f6b600ceb88f?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1621354598022-16599af1b8b2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1533222481259-ce20eda1e20b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1489710437720-ebb67ec84dd2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1440288736878-766bd5839edb?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Product 2 Description',
    }
    // Add more products as needed
  ];
  
  export default productp;
  